module.exports = __webpack_public_path__ + "static/media/icon-chrome.8762a6dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-chrome.svg
// module id = 304
// module chunks = 49